import { createTheme } from "@mui/material/styles";

/** Fingers, not a mouse: controls grow to at least 44 px (epic 5.1). */
export const COARSE = "@media (pointer: coarse)";
const touchTarget = { [COARSE]: { minWidth: 44, minHeight: 44 } };

// ATL palette from Atlantic UI's reference theme. Primary is darkened from
// hsl(254 70% 69%) so text and white-on-primary meet 4.5:1.
export const theme = createTheme({
  // Atlantic UI's layout overlays its menu below `sm` and keeps it beside the
  // page from `md`; a tablet held upright (800 px) gets the overlay.
  breakpoints: { values: { xs: 0, sm: 1000, md: 1000, lg: 1200, xl: 1536 } },
  components: {
    MuiButton: { styleOverrides: { root: { [COARSE]: { minHeight: 44 } } } },
    MuiIconButton: { styleOverrides: { root: touchTarget } },
    MuiToggleButton: { styleOverrides: { root: touchTarget } },
    MuiCheckbox: { styleOverrides: { root: touchTarget } },
    MuiInputBase: { styleOverrides: { root: { [COARSE]: { minHeight: 44 } } } },
    MuiFormControlLabel: {
      styleOverrides: { root: { [COARSE]: { minHeight: 44 } } },
    },
    MuiListItemButton: {
      styleOverrides: { root: { [COARSE]: { minHeight: 48 } } },
    },
    MuiSlider: {
      styleOverrides: {
        root: { [COARSE]: { paddingTop: 20, paddingBottom: 20 } },
        thumb: { [COARSE]: { width: 24, height: 24 } },
      },
    },
  },
  cssVariables: { colorSchemeSelector: "data-toolpad-color-scheme" },
  colorSchemes: {
    light: {
      palette: {
        primary: { main: "#5B3FC4" },
        secondary: { main: "#efe909" },
        background: {
          default: "hsl(251, 44%, 99%)",
          paper: "hsl(249, 47%, 99%)",
        },
      },
    },
    dark: {
      palette: {
        primary: { main: "#9882E0" },
        secondary: { main: "#efe909" },
      },
    },
  },
});
